export const DEFAULT_STATSIG_ECOMM_SSR_DYNAMIC_CONFIG = {
  isSignupOTPRequired: true,
  globalSignOutEnabled: true,
  disableCartEDDMessaging: true,
  useCustomerSearch: false,
  disableForceEDDForAgeRestrictedProducts: false,
  disableAgeVerification: false,
  showMultipleShipmentsInOrderDetails: false,
  showMultipleShipmentsInOrderList: false,
  useEfaKeyForEfaRecommendations: true,
  recentlyViewedProductsConstants: {
    recentlyViewedProductsCleanupTime: 2592000000,
    maxColorsPerProduct: 5,
    maxSavedRecentlyViewedProducts: 9,
    maxProductsDesktop: 8,
    maxProductsMobile: 9,
  },
  imageUploadLimitReturn: 3,
  isNewCartCollectionsEnabled: false,
  hiddenMenuItems: [] as { filterKey: string; filterValue: string }[],
  fmoOrderSearchPeriodValue: 2,
  fmoOrderSearchPeriodUnit: 'years' as 'days' | 'years',
  fingerprintCacheTTL: 86400000, // 1 day
  enableFMOForGuestUser: false,
  enableCarrierAlignedStatus: false,
}
